import React, { Component } from "react";
import LogoC from "../../../assets/image/logo.svg";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import Alert from "/src/util/alert";

import { USER_LOGIN } from "../../config/lang";

import { auth } from "../../util/action";
import { login } from "../../util/redux/actions";
import { translate } from "../../util/util";

class Login extends Component {
  constructor(props) {
    super(props);

    this.state = {
      phone_number: "",
      password: "",
      loading: false,
      errors: {},
    };
  }

  handleKeyPress = e => {
    if (e.nativeEvent.keyCode === 13) {
      this.login();
    }
  };

  change = field => {
    this.setState(field, () => {
      this.setState({ errors: {} });
    });
  };

  login = () => {
    const { dispatch, history } = this.props;
    let { phone_number, password } = this.state;

    phone_number = phone_number.trim();
    this.setState({ loading: true });

    auth({ phone_number: phone_number, password: password })
      .then(res => {
        if (res.user) {
          if (res.user.role == "supervisor" || res.user.role == "supervisor_manager") {
            res.user.key = res.key;
            res.user.company = res.related.company;
            res.user.client = res.related.client;
            res.user.county = res.related.county;

            Alert.success(translate(USER_LOGIN, "login_success_msg", "en"));

            dispatch(login(res.user));
            history.replace("/photo-review");
            window.location.reload();
          } else {
            Alert.error("Currently just users with SUPERVISOR role allowed to enter the system");
          }
        } else {
          Alert.error(translate(USER_LOGIN, "login_error_msg", "en"));
        }
      })
      .catch(err => {
        Alert.error(String(err));
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  };

  render() {
    const { phone_number, password, loading } = this.state;

    return (
      <div className="md-login-page">
        <div className="md-login-card">
          <div className="md-login-logo">
            <img src={LogoC} alt="PicSell" />
          </div>
          <div className="md-login-subtitle">Вхід до PicSell Dashboard</div>

          <div className="md-login-field">
            <label>Телефон</label>
            <input
              type="tel"
              placeholder="+380…"
              value={phone_number}
              onChange={e => this.change({ phone_number: e.target.value })}
              onKeyPress={this.handleKeyPress}
            />
          </div>

          <div className="md-login-field">
            <label>Пароль</label>
            <input
              type="password"
              placeholder="••••••••"
              value={password}
              onChange={e => this.change({ password: e.target.value })}
              onKeyPress={this.handleKeyPress}
            />
          </div>

          <button
            className="md-login-btn"
            onClick={this.login}
            disabled={loading}
          >
            {loading && <i className="fa fa-spinner fa-pulse fa-fw" />}
            Увійти
          </button>

          <div>
            <Link to="/forgot-password" className="md-login-forgot">
              Забули пароль?
            </Link>
          </div>
        </div>
      </div>
    );
  }
}

Login = connect(state => ({ me: state.me }))(Login);

export default withRouter(Login);
